module.exports = __webpack_public_path__ + "img/seminar.c3341dfe.png";